import "./polyfills/modern";
import { App } from "Core/App";

window._wecApp = new App(); // initialize App
